// src/lib/accountDeletion.js
import { supabase } from "../../supabaseClient";

async function readFunctionError(error) {
  try {
    const response = error?.context;

    if (response && typeof response.json === "function") {
      const payload = await response.json();

      return (
        payload?.error ||
        payload?.message ||
        error?.message ||
        "Could not delete your account."
      );
    }
  } catch {}

  return error?.message || "Could not delete your account.";
}

export async function deleteCurrentUserAccount({
  primaryReason,
  reasonDetails = "",
  additionalFeedback = "",
  experienceRating = null,
  wouldReturn = null,
  confirmationText,
  confirmedIrreversible,
  metadata = {},
}) {
  const {
    data: { session },
    error: sessionError,
  } = await supabase.auth.getSession();

  if (sessionError) throw sessionError;

  if (!session?.access_token) {
    throw new Error("Your session has expired. Please log in and try again.");
  }

  const { data, error } = await supabase.functions.invoke("delete-account", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
    },
    body: {
      primaryReason,
      reasonDetails,
      additionalFeedback,
      experienceRating,
      wouldReturn,
      confirmationText,
      confirmedIrreversible,
      metadata,
    },
  });

  if (error) {
    throw new Error(await readFunctionError(error));
  }

  if (!data?.success) {
    throw new Error(data?.error || "Could not delete your account.");
  }

  return data;
}